"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartContainer = exports.ChartContainerNoResizeDetection = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var fp_1 = require("lodash/fp");
var react_resize_detector_1 = require("react-resize-detector");
var Header_1 = require("../Header");
var DEFAULT_BREAKPOINTS = {
    small: [500, 360],
    medium: [1200, 400],
};
var ChartContainerNoResizeDetection = (function (_super) {
    tslib_1.__extends(ChartContainerNoResizeDetection, _super);
    function ChartContainerNoResizeDetection(props) {
        var _this = _super.call(this, props) || this;
        _this.createAttributes = _this.createAttributes.bind(_this);
        _this.onHeaderResize = _this.onHeaderResize.bind(_this);
        _this.ChartContainer = null;
        _this.state = {
            showChartHeader: true,
            chartHeaderHeight: Header_1.DEFAULT_CHART_HEADER_HEIGHT,
        };
        return _this;
    }
    ChartContainerNoResizeDetection.prototype.componentDidMount = function () {
        this.createAttributes();
    };
    ChartContainerNoResizeDetection.prototype.componentDidUpdate = function () {
        this.createAttributes();
    };
    ChartContainerNoResizeDetection.prototype.onHeaderResize = function (newHeaderHeight) {
        this.setState({
            chartHeaderHeight: newHeaderHeight,
        });
    };
    ChartContainerNoResizeDetection.prototype.createAttributes = function () {
        var _a = this.props, onChartResize = _a.onChartResize, _b = _a.breakpoints, breakpoints = _b === void 0 ? DEFAULT_BREAKPOINTS : _b;
        var chartHeaderHeight = this.state.chartHeaderHeight;
        var width = this.ChartContainer && this.ChartContainer.clientWidth;
        var height = this.ChartContainer && this.ChartContainer.clientHeight;
        if (!width)
            width = breakpoints.small[0];
        if (!height)
            height = breakpoints.small[1];
        var showChartHeader = height > breakpoints.medium[1];
        height = showChartHeader ? height - chartHeaderHeight : height;
        this.setState({
            showChartHeader: showChartHeader,
        });
        onChartResize(width, height);
    };
    ChartContainerNoResizeDetection.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, _b = _a.tagsLegendColorScale, tagsLegendColorScale = _b === void 0 ? fp_1.noop : _b, _c = _a.tagsLegendData, tagsLegendData = _c === void 0 ? [{}] : _c, onClickReset = _a.onClickReset, zoomable = _a.zoomable, onClickZoomIn = _a.onClickZoomIn, onClickZoomOut = _a.onClickZoomOut, disableZoomIn = _a.disableZoomIn, disableZoomOut = _a.disableZoomOut, disableReset = _a.disableReset, onClickLegendItem = _a.onClickLegendItem, onClickDeselectAll = _a.onClickDeselectAll, onClickSelectAll = _a.onClickSelectAll, onMouseOutLegendItem = _a.onMouseOutLegendItem, onMouseOverLegendItem = _a.onMouseOverLegendItem, _d = _a.selectableLegend, selectableLegend = _d === void 0 ? false : _d, _e = _a.hideChartHeader, hideChartHeader = _e === void 0 ? false : _e;
        var showChartHeader = this.state.showChartHeader;
        return (react_1.default.createElement("div", { style: {
                width: '100%',
                height: '100%',
            }, ref: function (el) { return (_this.ChartContainer = el); }, className: "FOS_ChartContainer" },
            showChartHeader && (react_1.default.createElement(Header_1.ChartHeader, { onClickReset: onClickReset, zoomable: zoomable, onClickZoomIn: onClickZoomIn, onClickZoomOut: onClickZoomOut, disableZoomIn: disableZoomIn, disableZoomOut: disableZoomOut, disableReset: disableReset, legendData: tagsLegendData, legendColorScale: tagsLegendColorScale, selectableLegend: selectableLegend, onHeaderResize: this.onHeaderResize, onClickLegendItem: onClickLegendItem, onClickDeselectAll: onClickDeselectAll, onClickSelectAll: onClickSelectAll, onMouseOutLegendItem: onMouseOutLegendItem, onMouseOverLegendItem: onMouseOverLegendItem, hideChartHeader: hideChartHeader })),
            children));
    };
    return ChartContainerNoResizeDetection;
}(react_1.PureComponent));
exports.ChartContainerNoResizeDetection = ChartContainerNoResizeDetection;
exports.ChartContainer = react_resize_detector_1.withResizeDetector(ChartContainerNoResizeDetection);
